import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { userStatusSelector } from '@selectors/global';

const EditableRoute = ({ userStatus, component: Component, ...rest }) => {
  const isReadOnly = userStatus.get('readOnly');
  return (
    <Route
      render={(props) => <Component {...props} isReadOnly={isReadOnly} />}
      {...rest}
    />
  );
};

EditableRoute.propTypes = {
  render: PropTypes.func,
  userStatus: PropTypes.any,
  component: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  userStatus: userStatusSelector,
});

export default connect(mapStateToProps, null)(EditableRoute);
